import { fetch } from '../utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryGoodsBrands(
  {
    page, size, direction, sort, name
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-brands`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
      name
    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryGoodsBrand(goodsBrandId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-brands/${goodsBrandId}`,
    method: 'get',
  });
}

/**
 * 新增
 * @param  name
 * @param  coverPath
 * @param  description
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addGoodsBrand(
  {
    name,
    coverPath,
    description,
    subName,
    icon,
    publishTime
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-brands`,
    method: 'post',
    data: {
      name,
      coverPath,
      description,
      subName,
      icon,
      publishTime

    },
  });
}

/**
 * 更新
 * @param goodsBrandId
 * @param  name
 * @param  coverPath
 * @param  description
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateGoodsBrand(goodsBrandId, {
  name,
  coverPath,
  description,
  subName,
  icon,
  publishTime
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-brands/${goodsBrandId}`,
    method: 'patch',
    data: {
      name,
      coverPath,
      description,
      subName,
      icon,
      publishTime
    },
  });
}

/**
 * 删除
 * @param goodsBrandId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteGoodsBrand(goodsBrandId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-brands/${goodsBrandId}`,
    method: 'delete',
  });
}

export default {};
